import { LoaderButton } from '@/common/components/loader-button';
import Spacer from '@/common/components/spacer';
import { Input } from '@/shadcn-ui/input';
import { cn } from '@/shadcn-ui/utils';
import { Form } from 'react-router';

interface MailingListProps {
  showSignUpSuccess?: boolean;
}

export default function MailingList({ showSignUpSuccess }: MailingListProps) {
  return (
    <div className="flex flex-col text-center">
      <h4 className={cn('header-sans-tight')}>Join our mailing list</h4>
      <Spacer variant="height8" />
      <p className={cn('homepage-hero-body2')}>
        Subscribe for more than just updates— get exclusive deals, first dibs on new
        rides, and fun surprises. We promise, no daily spam, just the good stuff!
      </p>
      <Spacer variant="height16" />
      <Form
        method="post"
        className="flex w-full flex-col justify-center gap-[16px] sm:flex-row sm:gap-[8px]"
      >
        <div className="flex flex-col text-left">
          <Input
            name="email"
            className={cn(
              'body h-[56px] w-full rounded-[64px] border border-flexcar-neutral80 bg-flexcar-neutral100 p-[16px] text-flexcar-neutral50 shadow-inputShadow sm:w-[340px]'
            )}
            placeholder="name@email.com"
            helperText={showSignUpSuccess ? `You're signed up!` : undefined}
          />
        </div>
        <LoaderButton
          type="submit"
          size="big"
          name="intent"
          value="sign_up_for_mailing_list"
          variant="homepage"
          className="flex items-center justify-center rounded-[40px] border-flexcar-neutral1 bg-flexcar-neutral1 px-[48px] py-[12px] text-flexcar-neutral100 ring-0 hover:bg-flexcar-neutral1/80 hover:text-flexcar-neutral100 hover:shadow-shadow20 hover:ring-transparent active:bg-flexcar-neutral1/80 active:text-flexcar-neutral100"
        >
          <p className={cn('button1')}>Sign up</p>
        </LoaderButton>
      </Form>
    </div>
  );
}
